import {
  UnauthorizedPopupAction,
  UnauthorizedPopupState,
} from "@model/Authentication.model";
import { UNAUTHORIZED_POPUP_CLEAR, UNAUTHORIZED_POPUP_SHOW } from "Data/UnauthorizedPopup/UnauthorizedPopupActionTypes";

const INITIAL_STATE: UnauthorizedPopupState = {
  message: null,
};

export const UnauthorizedPopupReducer = (
  state: UnauthorizedPopupState = INITIAL_STATE,
  action: UnauthorizedPopupAction
): UnauthorizedPopupState => {
  switch (action.type) {
    case UNAUTHORIZED_POPUP_SHOW:
      return {
        message: action.payload?.message ?? null,
      };

    case UNAUTHORIZED_POPUP_CLEAR:
      return {
        message: null,
      };

    default:
      return state;
  }
};
